import api from './api';

export const getGoals               = ()             => api.get('/goals').then(r => r.data);
export const createGoal             = (data)         => api.post('/goals', data).then(r => r.data);
export const updateGoal             = (id, data)     => api.put(`/goals/${id}`, data).then(r => r.data);
export const deleteGoal             = (id)           => api.delete(`/goals/${id}`).then(r => r.data);
export const createMilestone        = (goalId, data) => api.post(`/goals/${goalId}/milestones`, data).then(r => r.data);
export const updateMilestone        = (id, data)     => api.put(`/goals/milestones/${id}`, data).then(r => r.data);
export const deleteMilestone        = (id)           => api.delete(`/goals/milestones/${id}`).then(r => r.data);
export const markMilestoneReached   = (id)           => api.post(`/goals/milestones/${id}/reach`).then(r => r.data);
export const unmarkMilestoneReached = (id)           => api.delete(`/goals/milestones/${id}/reach`).then(r => r.data);
export const getTopMilestones       = ()             => api.get('/goals/top-milestones').then(r => r.data);
